import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "" }
const _hoisted_2 = { id: "southeast-scroll-wrapper" }
const _hoisted_3 = {
  class: "map-figure map-scroll-wrapper__map",
  id: "southeast-scroll-wrapper-item"
}
const _hoisted_4 = ["src"]
const _hoisted_5 = { class: "map-figure__layer" }
const _hoisted_6 = {
  class: "map-figure__svg",
  width: "1920",
  height: "700",
  viewBox: "0 0 1920 700",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  "xmlns:xlink": "http://www.w3.org/1999/xlink"
}
const _hoisted_7 = { class: "event" }
const _hoisted_8 = ["id"]
const _hoisted_9 = ["id"]
const _hoisted_10 = ["id"]
const _hoisted_11 = ["id"]
const _hoisted_12 = ["id"]
const _hoisted_13 = ["id"]
const _hoisted_14 = ["id"]
const _hoisted_15 = ["id"]
const _hoisted_16 = ["id"]
const _hoisted_17 = ["id"]
const _hoisted_18 = ["id"]
const _hoisted_19 = ["id"]
const _hoisted_20 = ["id"]
const _hoisted_21 = ["id"]
const _hoisted_22 = ["id"]
const _hoisted_23 = ["id"]
const _hoisted_24 = ["id"]
const _hoisted_25 = ["id"]
const _hoisted_26 = ["id"]
const _hoisted_27 = ["id"]
const _hoisted_28 = ["id"]
const _hoisted_29 = ["id"]
const _hoisted_30 = ["id"]
const _hoisted_31 = ["id"]
const _hoisted_32 = ["id"]
const _hoisted_33 = ["id"]
const _hoisted_34 = ["id"]
const _hoisted_35 = ["id"]
const _hoisted_36 = ["id"]
const _hoisted_37 = ["id"]
const _hoisted_38 = ["id"]
const _hoisted_39 = ["id"]
const _hoisted_40 = ["id"]
const _hoisted_41 = ["id"]
const _hoisted_42 = ["id"]
const _hoisted_43 = ["id"]
const _hoisted_44 = ["id"]
const _hoisted_45 = ["id"]
const _hoisted_46 = ["id"]
const _hoisted_47 = ["id"]
const _hoisted_48 = ["id"]
const _hoisted_49 = ["id"]
const _hoisted_50 = ["src"]

import { cardSettingsStore } from '@/store/modules/CardSettings';
import { landPlotStore } from '@/store/modules/LandPLot';
import { MixinDetailSection } from '@/mixins/MixinDetailSection';
import { getURL } from '@/helpers/routeHelpers';


export default /*@__PURE__*/_defineComponent({
  __name: 'SoutheastDetail',
  setup(__props) {

MixinDetailSection();

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("img", {
          class: "map-figure__bg",
          src: `${_unref(getURL)()}/${require('@/assets/img/Map/newsoutheast-map.png')}`
        }, null, 8, _hoisted_4),
        _createElementVNode("figure", _hoisted_5, [
          (_openBlock(), _createElementBlock("svg", _hoisted_6, [
            _createElementVNode("g", _hoisted_7, [
              _createElementVNode("g", null, [
                _createElementVNode("path", {
                  id: `id_${_unref(landPlotStore).HOUSE_TO_PLOT_NUMBER_MAP.get('401')}`,
                  d: "M860.999 347.487C841.217 347.519 806.079 348.308 799.185 348.468C798.52 348.483 797.989 347.879 797.984 347.124L797.496 275.87C797.494 275.625 797.551 275.384 797.661 275.172L809.681 252.096C809.877 251.719 810.201 251.474 810.586 251.442C820.291 250.634 854.075 250.517 860.821 250.502C861.479 250.501 861.999 251.104 862.001 251.85L862.261 345.871C862.226 346.795 861.666 347.512 860.999 347.487Z",
                  fill: "#2BB673",
                  "fill-opacity": "0.25",
                  stroke: "#2BB673",
                  "stroke-width": "0.641382"
                }, null, 8, _hoisted_8),
                _createElementVNode("path", {
                  id: `id_${_unref(landPlotStore).HOUSE_TO_PLOT_NUMBER_MAP.get('441')}`,
                  d: "M835.683 647.177C835.617 647.17 835.551 647.157 835.486 647.138L818.483 642.059C817.986 641.91 817.626 641.395 817.592 640.784L802.805 557.973C802.76 557.159 803.3 556.469 803.982 556.469L867.622 556.469C868.295 556.469 868.832 557.141 868.801 557.944L868.962 649.123C868.93 649.955 868.304 650.573 867.615 650.454L835.683 647.177Z",
                  fill: "#2BB673",
                  "fill-opacity": "0.25",
                  stroke: "#2BB673",
                  "stroke-width": "0.641382"
                }, null, 8, _hoisted_9),
                _createElementVNode("path", {
                  id: `id_${_unref(landPlotStore).HOUSE_TO_PLOT_NUMBER_MAP.get('428')}`,
                  d: "M879.465 554.259L801.986 554.492C801.292 554.494 800.745 553.787 800.805 552.964L802.179 476.383C802.208 475.986 802.377 475.625 802.64 475.387C802.711 475.322 802.793 475.277 802.876 475.235L815.995 468.705C816.078 468.664 816.157 468.613 816.239 468.569C816.387 468.49 816.548 468.447 816.711 468.444L882.603 467.492C883.284 467.482 883.831 468.155 883.799 468.963L880.643 552.918C880.614 553.667 880.096 554.257 879.465 554.259Z",
                  fill: "#D82D2D",
                  "fill-opacity": "0.25",
                  stroke: "#D82D2D"
                }, null, 8, _hoisted_10),
                _createElementVNode("path", {
                  id: `id_${_unref(landPlotStore).HOUSE_TO_PLOT_NUMBER_MAP.get('415')}`,
                  d: "M977.48 435.062L922.286 435.609C921.601 435.616 921.041 434.922 921.038 434.061L920.709 350.321C920.706 349.46 921.26 348.759 921.945 348.757L976.114 348.609C976.789 348.608 977.342 349.286 977.355 350.134L978.709 433.474C978.723 434.341 978.17 435.056 977.48 435.062Z",
                  fill: "#2BB673",
                  "fill-opacity": "0.25",
                  stroke: "#2BB673",
                  "stroke-width": "0.641382"
                }, null, 8, _hoisted_11),
                _createElementVNode("path", {
                  id: `id_${_unref(landPlotStore).HOUSE_TO_PLOT_NUMBER_MAP.get('403')}`,
                  d: "M977.462 346.586L921.953 347.586C921.25 347.586 920.687 346.782 920.708 345.81L919.581 251.259C919.601 250.327 920.152 249.586 920.826 249.586L975.462 249.586C976.15 249.586 976.707 250.358 976.707 251.31L978.707 344.862C978.707 345.814 978.15 346.586 977.462 346.586Z",
                  fill: "#2BB673",
                  "fill-opacity": "0.25",
                  stroke: "#2BB673",
                  "stroke-width": "0.641382"
                }, null, 8, _hoisted_12),
                _createElementVNode("path", {
                  id: `id_${_unref(landPlotStore).HOUSE_TO_PLOT_NUMBER_MAP.get('417')}`,
                  d: "M860.709 351.231L858.559 436.301C858.538 437.123 858.024 437.785 857.38 437.819L810.812 439.608C810.542 439.623 810.276 439.524 810.055 439.327L800.237 430.599C799.88 430.281 799.681 429.747 799.713 429.194L797.256 352.161C797.304 351.342 797.838 350.708 798.483 350.707L859.476 349.609C860.173 349.608 860.732 350.343 860.709 351.231Z",
                  fill: "#2BB673",
                  "fill-opacity": "0.25",
                  stroke: "#2BB673",
                  "stroke-width": "0.641382"
                }, null, 8, _hoisted_13),
                _createElementVNode("path", {
                  id: `id_${_unref(landPlotStore).HOUSE_TO_PLOT_NUMBER_MAP.get('416')}`,
                  d: "M918.479 435.704L861.972 436.609C861.262 436.621 860.688 435.895 860.71 435.015L862.858 351.106C862.88 350.27 863.433 349.607 864.108 349.609L917.809 349.804C918.491 349.806 919.045 350.488 919.052 351.334L919.709 434.143C919.716 434.995 919.166 435.693 918.479 435.704Z",
                  fill: "#2BB673",
                  "fill-opacity": "0.25",
                  stroke: "#2BB673",
                  "stroke-width": "0.641382"
                }, null, 8, _hoisted_14),
                _createElementVNode("path", {
                  id: `id_${_unref(landPlotStore).HOUSE_TO_PLOT_NUMBER_MAP.get('402')}`,
                  d: "M919.48 346.672C919.489 347.426 918.951 347.996 918.285 347.996L865.693 347.996C865.032 347.996 864.496 347.433 864.498 346.684C864.533 336.035 864.758 263.857 864.527 251.291C864.513 250.551 864.993 249.966 865.646 249.944C874.33 249.65 910.14 249.932 916.894 249.989C917.52 249.994 918.023 250.513 918.049 251.222C918.496 263.59 919.355 335.963 919.48 346.672Z",
                  fill: "#2BB673",
                  "fill-opacity": "0.25",
                  stroke: "#2BB673",
                  "stroke-width": "0.641382"
                }, null, 8, _hoisted_15),
                _createElementVNode("path", {
                  id: `id_${_unref(landPlotStore).HOUSE_TO_PLOT_NUMBER_MAP.get('404')}`,
                  d: "M1035.48 344.243L980.979 345.585C980.279 345.603 979.706 344.823 979.707 343.856L978.87 251.307C978.872 250.354 979.432 249.584 980.121 249.586L1034.33 248.687C1035 248.689 1035.55 249.425 1035.57 250.352L1036.71 342.457C1036.73 343.421 1036.18 344.225 1035.48 344.243Z",
                  fill: "#2BB673",
                  "fill-opacity": "0.25",
                  stroke: "#2BB673",
                  "stroke-width": "0.641382"
                }, null, 8, _hoisted_16),
                _createElementVNode("path", {
                  id: `id_${_unref(landPlotStore).HOUSE_TO_PLOT_NUMBER_MAP.get('439')}`,
                  d: "M927.58 660.876L926.803 557.188C926.797 556.407 927.335 555.77 928.002 555.767L985.021 554.477C985.672 554.473 986.208 555.077 986.23 555.839L987.802 670.02C987.827 670.904 987.158 671.597 986.411 671.459L928.597 662.258C928.015 662.15 927.584 661.566 927.58 660.876Z",
                  fill: "#D82D2D",
                  "fill-opacity": "0.25",
                  stroke: "#D82D2D"
                }, null, 8, _hoisted_17),
                _createElementVNode("path", {
                  id: `id_${_unref(landPlotStore).HOUSE_TO_PLOT_NUMBER_MAP.get('430')}`,
                  d: "M995.603 551.913L940.022 552.492C939.341 552.499 938.789 551.851 938.802 551.059L940.118 466.872C940.13 466.114 940.657 465.505 941.308 465.493L994.153 463.492C994.819 463.48 995.367 464.095 995.381 464.869L996.801 550.479C996.815 551.261 996.276 551.907 995.603 551.913Z",
                  fill: "#2BB673",
                  "fill-opacity": "0.25",
                  stroke: "#2BB673",
                  "stroke-width": "0.641382"
                }, null, 8, _hoisted_18),
                _createElementVNode("path", {
                  id: `id_${_unref(landPlotStore).HOUSE_TO_PLOT_NUMBER_MAP.get('413')}`,
                  d: "M1096.48 431.529L1040.38 432.617C1039.7 432.63 1039.14 431.962 1039.12 431.114L1036.71 347.545C1036.68 346.666 1037.25 345.935 1037.95 345.931L1093.3 345.617C1093.96 345.613 1094.5 346.241 1094.55 347.056L1097.65 429.258C1097.66 429.732 1096.9 431.521 1096.48 431.529Z",
                  fill: "#2BB673",
                  "fill-opacity": "0.25",
                  stroke: "#2BB673",
                  "stroke-width": "0.641382"
                }, null, 8, _hoisted_19),
                _createElementVNode("path", {
                  id: `id_${_unref(landPlotStore).HOUSE_TO_PLOT_NUMBER_MAP.get('431')}`,
                  d: "M1055.6 552.324L999.755 552.492C999.099 552.494 998.561 551.887 998.544 551.124L996.802 465.675C996.785 464.892 997.322 464.245 997.995 464.236L1053.01 463.492C1053.66 463.484 1054.2 464.083 1054.23 464.843L1056.8 550.868C1056.83 551.662 1056.28 552.322 1055.6 552.324Z",
                  fill: "#2BB673",
                  "fill-opacity": "0.25",
                  stroke: "#2BB673",
                  "stroke-width": "0.641382"
                }, null, 8, _hoisted_20),
                _createElementVNode("path", {
                  id: `id_${_unref(landPlotStore).HOUSE_TO_PLOT_NUMBER_MAP.get('406')}`,
                  d: "M1147.44 342.585L1099.04 344.036C1098.4 344.015 1097.88 343.319 1097.84 342.431L1094.71 250.452C1094.66 249.457 1095.23 248.612 1095.94 248.612L1143.88 247.586C1144.52 247.586 1145.05 248.265 1145.11 249.153L1148.7 340.707C1148.77 341.732 1148.18 342.61 1147.44 342.585Z",
                  fill: "#2BB673",
                  "fill-opacity": "0.25",
                  stroke: "#2BB673",
                  "stroke-width": "0.641382"
                }, null, 8, _hoisted_21),
                _createElementVNode("path", {
                  id: `id_${_unref(landPlotStore).HOUSE_TO_PLOT_NUMBER_MAP.get('429')}`,
                  d: "M935.966 553.23L883.988 553.492C883.313 553.495 882.773 552.829 882.802 552.03L885.73 469.422C885.757 468.677 886.271 468.088 886.9 468.082L937.608 465.492C938.277 465.485 938.817 466.136 938.801 466.928L937.143 551.864C937.127 552.622 936.605 553.227 935.966 553.23Z",
                  fill: "#2BB673",
                  "fill-opacity": "0.25",
                  stroke: "#2BB673",
                  "stroke-width": "0.641382"
                }, null, 8, _hoisted_22),
                _createElementVNode("path", {
                  id: `id_${_unref(landPlotStore).HOUSE_TO_PLOT_NUMBER_MAP.get('414')}`,
                  d: "M1036.48 433.942L981.215 434.609C980.537 434.617 979.98 433.941 979.967 433.093L978.709 348.389C978.696 347.535 979.24 346.83 979.924 346.815L1034.06 345.61C1034.74 345.595 1035.3 346.258 1035.32 347.1L1037.71 432.342C1037.73 433.211 1037.18 433.934 1036.48 433.942Z",
                  fill: "#2BB673",
                  "fill-opacity": "0.25",
                  stroke: "#2BB673",
                  "stroke-width": "0.641382"
                }, null, 8, _hoisted_23),
                _createElementVNode("path", {
                  id: `id_${_unref(landPlotStore).HOUSE_TO_PLOT_NUMBER_MAP.get('405')}`,
                  d: "M1094.47 344.01L1040.15 344.584C1039.48 344.591 1038.92 343.856 1038.89 342.926L1037.71 251.365C1037.68 250.386 1038.26 249.576 1038.97 249.584L1091.78 248.172C1092.44 248.179 1092.98 248.885 1093.02 249.787L1095.71 342.186C1095.75 343.17 1095.18 344.002 1094.47 344.01Z",
                  fill: "#2BB673",
                  "fill-opacity": "0.25",
                  stroke: "#2BB673",
                  "stroke-width": "0.641382"
                }, null, 8, _hoisted_24),
                _createElementVNode("path", {
                  id: `id_${_unref(landPlotStore).HOUSE_TO_PLOT_NUMBER_MAP.get('440')}`,
                  d: "M925.013 556.861L925.802 661.053C925.808 661.926 925.133 662.594 924.391 662.449L871.81 651.385C871.208 651.267 870.776 650.647 870.803 649.939L870.63 557.81C870.659 557.06 871.191 556.469 871.838 556.469L923.803 555.469C924.467 555.469 925.007 556.09 925.013 556.861Z",
                  fill: "#D82D2D",
                  "fill-opacity": "0.25",
                  stroke: "#D82D2D"
                }, null, 8, _hoisted_25),
                _createElementVNode("path", {
                  id: `id_${_unref(landPlotStore).HOUSE_TO_PLOT_NUMBER_MAP.get('438')}`,
                  d: "M1093.7 610.426L1067.33 672.431C1067.23 672.705 1067.05 672.935 1066.83 673.086L1053.3 682.284C1053.06 682.447 1052.79 682.51 1052.51 682.459C1036.12 679.417 997.483 673.049 991.626 672.025C991.052 671.925 990.631 671.364 990.612 670.69L988.803 611.432C988.781 610.65 989.316 609.999 989.988 609.988L1092.58 608.477C1093.45 608.462 1094.05 609.495 1093.7 610.426Z",
                  fill: "#D82D2D",
                  "fill-opacity": "0.25",
                  stroke: "#D82D2D"
                }, null, 8, _hoisted_26),
                _createElementVNode("path", {
                  id: `id_${_unref(landPlotStore).HOUSE_TO_PLOT_NUMBER_MAP.get('437')}`,
                  d: "M1093.52 606.923L989.852 608.476C989.211 608.487 988.679 607.882 988.654 607.114L987.804 555.95C987.778 555.145 988.314 554.477 988.985 554.477L1113.62 553.477C1114.47 553.477 1115.04 554.523 1114.7 555.459L1094.59 606.07C1094.4 606.582 1093.99 606.916 1093.52 606.923Z",
                  fill: "#D82D2D",
                  "fill-opacity": "0.25",
                  stroke: "#D82D2D"
                }, null, 8, _hoisted_27),
                _createElementVNode("path", {
                  id: `id_${_unref(landPlotStore).HOUSE_TO_PLOT_NUMBER_MAP.get('432')}`,
                  d: "M1117.34 551.492L1059.5 551.361C1058.86 551.359 1058.33 550.761 1058.3 550.005L1055.8 463.772C1055.78 462.98 1056.31 462.32 1056.99 462.313L1137.41 461.492C1137.73 461.489 1138.04 461.636 1138.26 461.901L1144.45 469.123C1144.79 469.526 1144.9 470.135 1144.71 470.663L1118.45 550.627C1118.26 551.152 1117.82 551.493 1117.34 551.492Z",
                  fill: "#2BB673",
                  "fill-opacity": "0.25",
                  stroke: "#2BB673",
                  "stroke-width": "0.641382"
                }, null, 8, _hoisted_28),
                _createElementVNode("path", {
                  id: `id_${_unref(landPlotStore).HOUSE_TO_PLOT_NUMBER_MAP.get('412')}`,
                  d: "M1191.5 345.625L1161.47 422.078C1161.37 422.383 1161.19 422.638 1160.96 422.805L1149.51 431.208C1149.33 431.344 1149.12 431.416 1148.9 431.417L1100.63 431.617C1099.99 431.619 1099.45 430.99 1099.4 430.177L1096.71 347.278C1096.66 346.363 1097.24 345.592 1097.97 345.617L1149.5 344.5L1190.35 343.461C1191.24 343.44 1191.85 344.59 1191.5 345.625Z",
                  fill: "#2BB673",
                  "fill-opacity": "0.25",
                  stroke: "#2BB673",
                  "stroke-width": "0.641382"
                }, null, 8, _hoisted_29),
                _createElementVNode("path", {
                  id: `id_${_unref(landPlotStore).HOUSE_TO_PLOT_NUMBER_MAP.get('407')}`,
                  d: "M1191.54 341.168L1151.15 341.586C1150.51 341.593 1149.97 340.924 1149.91 340.044L1146.71 249.546C1146.64 248.544 1147.21 247.67 1147.93 247.658L1218.97 247.586C1219.29 247.581 1219.59 247.74 1219.83 248.033L1225.3 254.913C1225.7 255.409 1225.82 256.198 1225.6 256.872L1192.67 340.144C1192.47 340.762 1192.03 341.163 1191.54 341.168Z",
                  fill: "#2BB673",
                  "fill-opacity": "0.25",
                  stroke: "#2BB673",
                  "stroke-width": "0.641382"
                }, null, 8, _hoisted_30),
                _createElementVNode("path", {
                  id: `id_${_unref(landPlotStore).HOUSE_TO_PLOT_NUMBER_MAP.get('370')}`,
                  d: "M813.177 217.835L834.25 139.426C834.398 138.873 834.895 138.486 835.467 138.476L894.218 137.513C894.926 137.502 895.51 138.066 895.522 138.774L896.979 226.223C896.991 226.926 896.434 227.507 895.731 227.526L823.108 229.476C822.724 229.486 822.355 229.323 822.103 229.032L813.445 219.007C813.167 218.685 813.067 218.246 813.177 217.835Z",
                  fill: "#2BB673",
                  "fill-opacity": "0.25",
                  stroke: "#2BB673",
                  "stroke-width": "0.641382"
                }, null, 8, _hoisted_31),
                _cache[0] || (_cache[0] = _createElementVNode("path", {
                  d: "M768.476 233L714.282 233C713.574 233 713 232.426 713 231.717L713 157.249C713 156.554 713.553 155.985 714.248 155.967L785.848 154.044C786.685 154.022 787.319 154.795 787.133 155.612L769.727 232.002C769.594 232.586 769.075 233 768.476 233Z",
                  fill: "#82B941",
                  "fill-opacity": "0.25",
                  stroke: "#82B941",
                  "stroke-width": "0.641382"
                }, null, -1)),
                _createElementVNode("path", {
                  id: `id_${_unref(landPlotStore).HOUSE_TO_PLOT_NUMBER_MAP.get('371')}`,
                  d: "M898.979 226.231L897.521 138.739C897.51 138.045 898.053 137.467 898.746 137.436L940.682 135.551C941.404 135.519 942.01 136.089 942.022 136.812L943.479 226.189C943.491 226.905 942.913 227.492 942.197 227.492L900.262 227.492C899.562 227.492 898.991 226.931 898.979 226.231Z",
                  fill: "#2BB673",
                  "fill-opacity": "0.25",
                  stroke: "#2BB673",
                  "stroke-width": "0.641382"
                }, null, 8, _hoisted_32),
                _createElementVNode("path", {
                  id: `id_${_unref(landPlotStore).HOUSE_TO_PLOT_NUMBER_MAP.get('372')}`,
                  d: "M945.265 135.469L983.214 134.532C983.924 134.514 984.513 135.076 984.528 135.786L986.472 225.221C986.488 225.928 985.928 226.514 985.221 226.531L946.299 227.469C945.585 227.486 944.994 226.915 944.986 226.2L944.014 136.765C944.006 136.064 944.563 135.486 945.265 135.469Z",
                  fill: "#2BB673",
                  "fill-opacity": "0.25",
                  stroke: "#2BB673",
                  "stroke-width": "0.641382"
                }, null, 8, _hoisted_33),
                _createElementVNode("path", {
                  id: `id_${_unref(landPlotStore).HOUSE_TO_PLOT_NUMBER_MAP.get('373')}`,
                  d: "M987.794 134.483L1024.21 134.016C1024.92 134.007 1025.51 134.576 1025.51 135.285L1026.49 225.203C1026.49 225.917 1025.92 226.5 1025.2 226.5L989.755 226.5C989.058 226.5 988.488 225.943 988.473 225.245L986.528 135.794C986.513 135.081 987.081 134.493 987.794 134.483Z",
                  fill: "#2BB673",
                  "fill-opacity": "0.25",
                  stroke: "#2BB673",
                  "stroke-width": "0.641382"
                }, null, 8, _hoisted_34),
                _createElementVNode("path", {
                  id: `id_${_unref(landPlotStore).HOUSE_TO_PLOT_NUMBER_MAP.get('374')}`,
                  d: "M1028.27 133.47L1068.23 132.53C1068.93 132.513 1069.52 133.067 1069.54 133.771L1072.46 224.191C1072.48 224.909 1071.91 225.507 1071.19 225.515L1029.78 225.985C1029.07 225.994 1028.49 225.43 1028.48 224.724L1027.02 134.773C1027.01 134.069 1027.57 133.487 1028.27 133.47Z",
                  fill: "#2BB673",
                  "fill-opacity": "0.25",
                  stroke: "#2BB673",
                  "stroke-width": "0.641382"
                }, null, 8, _hoisted_35),
                _createElementVNode("path", {
                  id: `id_${_unref(landPlotStore).HOUSE_TO_PLOT_NUMBER_MAP.get('375')}`,
                  d: "M1072.82 132L1112.75 132C1113.45 132 1114.01 132.553 1114.03 133.248L1116.47 223.213C1116.48 223.923 1115.92 224.514 1115.21 224.53L1075.28 225.47C1074.57 225.487 1073.98 224.928 1073.97 224.222L1071.54 133.317C1071.52 132.595 1072.1 132 1072.82 132Z",
                  fill: "#2BB673",
                  "fill-opacity": "0.25",
                  stroke: "#2BB673",
                  "stroke-width": "0.641382"
                }, null, 8, _hoisted_36),
                _createElementVNode("path", {
                  id: `id_${_unref(landPlotStore).HOUSE_TO_PLOT_NUMBER_MAP.get('376')}`,
                  d: "M1117.27 131.954L1155.71 130.547C1156.42 130.521 1157.02 131.077 1157.04 131.788L1159.96 222.207C1159.98 222.92 1159.42 223.514 1158.71 223.531L1119.78 224.469C1119.07 224.486 1118.49 223.928 1118.47 223.221L1116.04 133.27C1116.02 132.567 1116.57 131.979 1117.27 131.954Z",
                  fill: "#2BB673",
                  "fill-opacity": "0.25",
                  stroke: "#2BB673",
                  "stroke-width": "0.641382"
                }, null, 8, _hoisted_37),
                _createElementVNode("path", {
                  id: `id_${_unref(landPlotStore).HOUSE_TO_PLOT_NUMBER_MAP.get('377')}`,
                  d: "M1160.29 130.969L1199.22 130.031C1199.92 130.014 1200.51 130.576 1200.53 131.286L1202.47 221.706C1202.49 222.419 1201.92 223.007 1201.21 223.016L1163.26 223.484C1162.56 223.493 1161.98 222.941 1161.96 222.243L1159.04 132.293C1159.02 131.581 1159.58 130.986 1160.29 130.969Z",
                  fill: "#2BB673",
                  "fill-opacity": "0.25",
                  stroke: "#2BB673",
                  "stroke-width": "0.641382"
                }, null, 8, _hoisted_38),
                _createElementVNode("path", {
                  id: `id_${_unref(landPlotStore).HOUSE_TO_PLOT_NUMBER_MAP.get('378')}`,
                  d: "M1203.32 130L1273.66 130C1274.55 130 1275.17 130.89 1274.86 131.728L1245.63 210.646C1245.55 210.877 1245.4 211.079 1245.2 211.227L1229.84 222.743C1229.62 222.91 1229.35 223 1229.07 223L1205.75 223C1205.05 223 1204.49 222.446 1204.47 221.752L1202.04 131.317C1202.02 130.596 1202.6 130 1203.32 130Z",
                  fill: "#2BB673",
                  "fill-opacity": "0.25",
                  stroke: "#2BB673",
                  "stroke-width": "0.641382"
                }, null, 8, _hoisted_39),
                _createElementVNode("path", {
                  id: `id_${_unref(landPlotStore).HOUSE_TO_PLOT_NUMBER_MAP.get('360')}`,
                  d: "M861.477 44L892.738 44C893.438 44 894.009 44.5615 894.021 45.2616L895.479 133.728C895.491 134.432 894.932 135.014 894.228 135.032L836.728 136.457C835.867 136.478 835.231 135.663 835.459 134.834L860.24 44.9419C860.394 44.3855 860.9 44 861.477 44Z",
                  fill: "#2BB673",
                  "fill-opacity": "0.25",
                  stroke: "#2BB673",
                  "stroke-width": "0.641382"
                }, null, 8, _hoisted_40),
                _createElementVNode("path", {
                  id: `id_${_unref(landPlotStore).HOUSE_TO_PLOT_NUMBER_MAP.get('361')}`,
                  d: "M897.265 44.4553L937.208 43.0456C937.92 43.0205 938.516 43.5801 938.536 44.2921L940.965 132.227C940.984 132.932 940.432 133.52 939.727 133.544L899.298 134.955C898.584 134.98 897.987 134.416 897.971 133.701L896.028 45.7657C896.012 45.064 896.564 44.4801 897.265 44.4553Z",
                  fill: "#2BB673",
                  "fill-opacity": "0.25",
                  stroke: "#2BB673",
                  "stroke-width": "0.641382"
                }, null, 8, _hoisted_41),
                _createElementVNode("path", {
                  id: `id_${_unref(landPlotStore).HOUSE_TO_PLOT_NUMBER_MAP.get('362')}`,
                  d: "M941.772 42.9546L981.207 41.5462C981.92 41.5207 982.516 42.0806 982.536 42.7929L984.965 131.213C984.984 131.923 984.423 132.514 983.713 132.531L944.278 133.47C943.571 133.486 942.984 132.929 942.965 132.223L940.535 44.272C940.516 43.5678 941.068 42.9797 941.772 42.9546Z",
                  fill: "#2BB673",
                  "fill-opacity": "0.25",
                  stroke: "#2BB673",
                  "stroke-width": "0.641382"
                }, null, 8, _hoisted_42),
                _createElementVNode("path", {
                  id: `id_${_unref(landPlotStore).HOUSE_TO_PLOT_NUMBER_MAP.get('363')}`,
                  d: "M985.811 41.5L1023.23 41.5C1023.93 41.5 1024.51 42.0657 1024.51 42.7686L1025.49 130.72C1025.49 131.427 1024.93 132.007 1024.22 132.016L987.771 132.484C987.067 132.493 986.488 131.933 986.472 131.229L984.529 42.8109C984.513 42.0916 985.092 41.5 985.811 41.5Z",
                  fill: "#2BB673",
                  "fill-opacity": "0.25",
                  stroke: "#2BB673",
                  "stroke-width": "0.641382"
                }, null, 8, _hoisted_43),
                _createElementVNode("path", {
                  id: `id_${_unref(landPlotStore).HOUSE_TO_PLOT_NUMBER_MAP.get('364')}`,
                  d: "M1027.27 40.9693L1066.22 40.0308C1066.93 40.0138 1067.52 40.5714 1067.54 41.2778L1069.96 129.212C1069.98 129.923 1069.42 130.514 1068.71 130.53L1028.79 131.47C1028.08 131.486 1027.49 130.92 1027.48 130.208L1026.02 42.273C1026.01 41.5684 1026.57 40.9863 1027.27 40.9693Z",
                  fill: "#2BB673",
                  "fill-opacity": "0.25",
                  stroke: "#2BB673",
                  "stroke-width": "0.641382"
                }, null, 8, _hoisted_44),
                _createElementVNode("path", {
                  id: `id_${_unref(landPlotStore).HOUSE_TO_PLOT_NUMBER_MAP.get('365')}`,
                  d: "M1071.97 128.753L1069.54 41.7729C1069.52 41.0684 1070.07 40.4799 1070.77 40.4551L1110.7 39.0459C1111.42 39.0206 1112.01 39.5847 1112.03 40.2996L1113.97 128.689C1113.99 129.408 1113.41 130 1112.69 130L1073.25 130C1072.55 130 1071.98 129.447 1071.97 128.753Z",
                  fill: "#2BB673",
                  "fill-opacity": "0.25",
                  stroke: "#2BB673",
                  "stroke-width": "0.641382"
                }, null, 8, _hoisted_45),
                _createElementVNode("path", {
                  id: `id_${_unref(landPlotStore).HOUSE_TO_PLOT_NUMBER_MAP.get('366')}`,
                  d: "M1115.28 38.9695L1154.7 38.0309C1155.42 38.0139 1156.01 38.5843 1156.02 39.2992L1156.99 127.25C1156.99 127.945 1156.45 128.52 1155.75 128.546L1117.3 129.952C1116.59 129.979 1115.99 129.414 1115.97 128.699L1114.03 40.2801C1114.01 39.5727 1114.57 38.9864 1115.28 38.9695Z",
                  fill: "#2BB673",
                  "fill-opacity": "0.25",
                  stroke: "#2BB673",
                  "stroke-width": "0.641382"
                }, null, 8, _hoisted_46),
                _createElementVNode("path", {
                  id: `id_${_unref(landPlotStore).HOUSE_TO_PLOT_NUMBER_MAP.get('367')}`,
                  d: "M1158.8 38L1196.75 38C1197.45 38 1198.02 38.5528 1198.04 39.2471L1200.46 126.682C1200.48 127.404 1199.9 128 1199.18 128L1159.77 128C1159.07 128 1158.49 127.434 1158.49 126.731L1157.52 39.297C1157.51 38.583 1158.08 38 1158.8 38Z",
                  fill: "#2BB673",
                  "fill-opacity": "0.25",
                  stroke: "#2BB673",
                  "stroke-width": "0.641382"
                }, null, 8, _hoisted_47),
                _createElementVNode("path", {
                  id: `id_${_unref(landPlotStore).HOUSE_TO_PLOT_NUMBER_MAP.get('368')}`,
                  d: "M1201.27 37.4548L1240.71 36.0462C1241.42 36.0207 1242.02 36.5807 1242.04 37.2931L1244.46 126.182C1244.48 126.904 1243.9 127.5 1243.18 127.5L1203.26 127.5C1202.56 127.5 1201.99 126.943 1201.97 126.246L1200.03 38.7653C1200.01 38.0637 1200.56 37.4799 1201.27 37.4548Z",
                  fill: "#2BB673",
                  "fill-opacity": "0.25",
                  stroke: "#2BB673",
                  "stroke-width": "0.641382"
                }, null, 8, _hoisted_48),
                _createElementVNode("path", {
                  id: `id_${_unref(landPlotStore).HOUSE_TO_PLOT_NUMBER_MAP.get('369')}`,
                  d: "M1308 36.303L1308 45.2607C1308 45.4189 1307.97 45.5757 1307.91 45.7232L1276.82 126.18C1276.63 126.674 1276.15 127 1275.62 127L1247.75 127C1247.05 127 1246.49 126.447 1246.47 125.752L1244.04 37.2976C1244.02 36.5834 1244.58 35.9909 1245.3 35.9797L1306.7 35.0204C1307.41 35.0092 1308 35.5867 1308 36.303Z",
                  fill: "#2BB673",
                  "fill-opacity": "0.25",
                  stroke: "#2BB673",
                  "stroke-width": "0.641382"
                }, null, 8, _hoisted_49)
              ])
            ])
          ]))
        ]),
        _createElementVNode("img", {
          class: "map-figure__layer map-figure__layer--disabled",
          src: `${_unref(getURL)()}/${require('@/assets/img/Map/new2southeast-map-numbers.png')}`
        }, null, 8, _hoisted_50)
      ])
    ])
  ]))
}
}

})